type Props = {
  subtitle: string;
};

const SectionSubtitle = ({ subtitle }: Props) => {
  return (
    <p className="text-[1.5rem] font-medium">{subtitle}</p>
  );
};

export default SectionSubtitle;
